module.exports = __webpack_public_path__ + "img/draft_docs.4bb6d5b2.svg";